import { MONTHS_UA } from '@/features/annualOrderedCapacities/constants';

export const getMonthName = (monthNumber: number) => MONTHS_UA[monthNumber];
